export enum PreSignedUrlType {
    Download,
    Upload,
}
